import { refinementList } from "instantsearch.js/es/widgets";
import {
    catalogRefinementItem,
    catalogRefinementClasses,
} from "./tpl-catalogRefinement";

export const catalogSolutions = refinementList({
    container: "[data-widget='catalogSolutions']",
    sortBy: ["name:asc"],
    attribute: "Solutions",
    cssClasses: catalogRefinementClasses,
    templates: {
        item: catalogRefinementItem,
    },
});
